/**
 * @generated SignedSource<<80619f5859d3bb24bcc0918c377c5edd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type StatsSnapshotQuery$variables = {
  internalId?: string | null;
  username?: string | null;
};
export type StatsSnapshotQuery$data = {
  readonly unified: {
    readonly unifiedProfile: {
      readonly extensions?: ReadonlyArray<{
        readonly errorType: string | null;
        readonly statusCode: number | null;
      }> | null;
      readonly forums?: {
        readonly id?: string;
        readonly snapshot?: {
          readonly acceptedAnswersCreated?: number | null;
          readonly answersCreated?: number | null;
          readonly articlesCreated?: number | null;
          readonly extensions?: ReadonlyArray<{
            readonly errorType: string | null;
            readonly statusCode: number | null;
          }> | null;
          readonly id?: string;
          readonly identifier?: string | null;
          readonly kudosReceived?: number | null;
          readonly message?: string | null;
          readonly rank?: string | null;
          readonly totalPosts?: number | null;
        } | null;
      } | null;
      readonly identifier?: string | null;
      readonly message?: string | null;
    } | null;
  } | null;
};
export type StatsSnapshotQuery = {
  response: StatsSnapshotQuery$data;
  variables: StatsSnapshotQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "internalId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "username"
},
v2 = [
  {
    "kind": "Variable",
    "name": "internalId",
    "variableName": "internalId"
  },
  {
    "kind": "Variable",
    "name": "unifiedProfileUsername",
    "variableName": "username"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rank",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "acceptedAnswersCreated",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "answersCreated",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "articlesCreated",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "kudosReceived",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalPosts",
      "storageKey": null
    }
  ],
  "type": "UnifiedForumsSnapshot",
  "abstractKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "identifier",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UnifiedQueryErrorExtension",
      "kind": "LinkedField",
      "name": "extensions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "errorType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "statusCode",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UnifiedQueryError",
  "abstractKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "StatsSnapshotQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UnifiedQuery",
        "kind": "LinkedField",
        "name": "unified",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "unifiedProfile",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "forums",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "snapshot",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v5/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "UnifiedForums",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "UnifiedProfile",
                "abstractKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "StatsSnapshotQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UnifiedQuery",
        "kind": "LinkedField",
        "name": "unified",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "unifiedProfile",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "forums",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "snapshot",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v4/*: any*/),
                              (v5/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "UnifiedForums",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "type": "UnifiedProfile",
                "abstractKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "240bae1dfc1db346907fd5aa44217e4c",
    "id": null,
    "metadata": {},
    "name": "StatsSnapshotQuery",
    "operationKind": "query",
    "text": "query StatsSnapshotQuery(\n  $username: String\n  $internalId: String\n) {\n  unified {\n    unifiedProfile(unifiedProfileUsername: $username, internalId: $internalId) {\n      __typename\n      ... on UnifiedProfile {\n        forums {\n          __typename\n          ... on UnifiedForums {\n            id\n            snapshot {\n              __typename\n              ... on UnifiedForumsSnapshot {\n                id\n                rank\n                acceptedAnswersCreated\n                answersCreated\n                articlesCreated\n                kudosReceived\n                totalPosts\n              }\n              ... on UnifiedQueryError {\n                identifier\n                message\n                extensions {\n                  errorType\n                  statusCode\n                }\n              }\n            }\n          }\n        }\n        id\n      }\n      ... on UnifiedQueryError {\n        identifier\n        message\n        extensions {\n          errorType\n          statusCode\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c44743427e63c17dc954262421103bd0";

export default node;
